import React from "react";

const NullSafeText = ({ text }) => {
  return <>{text || "-"}</>;
};

export default NullSafeText;
